module.exports = __webpack_public_path__ + "static/media/pig-blue.f48f3f33.svg";